/**
 * Class composition for the primitives.
 *
 * `clsx` flattens conditionals; `tailwind-merge` resolves conflicts so that a caller's `className`
 * wins over a primitive's default instead of the two both landing in the attribute and the winner
 * being decided by stylesheet order — which is not something a caller can see or reason about.
 *
 * `tailwind-merge` is pinned to 2.x deliberately. 3.x targets Tailwind 4's generated theme, and this
 * repository is on 3.4.19 for the reason recorded in `pnpm-workspace.yaml`: the token format
 * requirement 6.1 asks for is a 3.x mechanism.
 *
 * One consequence worth naming: `twMerge` knows Tailwind's *default* scales, and this preset
 * replaces four of them (`colors`, `borderRadius`, `boxShadow`, and the motion scales). Conflict
 * resolution is by utility family rather than by value, so `shadow-raised` still displaces
 * `shadow-modal` — the family is what it groups on. Where it cannot help is a value it has never
 * heard of in a family it does not know, and there are none of those here.
 */
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export const cn = (...inputs) => twMerge(clsx(inputs));
//# sourceMappingURL=cn.js.map